// ABOUTME: Derives the spec sheet's quick-action states (saved / in bag / how many) from the
// ABOUTME: SAME cart + wishlist arrays the drawers render, so every surface agrees by construction.

import { itemQuantity } from '../../../utils/cartMath';

/**
 * Does this selection row stand for the sheet's piece?
 *
 * The sheet's only identity is `variant_id` (services/ui_payloads.reel_spec_sheet ships no
 * product id), and a row put there by the guest's own tap carries exactly that as its `id`.
 * The two tolerances are for rows that did NOT come from here: a `selection_state` hydration
 * row is the backend's resolved envelope, which may carry the variant under its own
 * `variant_id` key and may differ in case/whitespace. Matching only on strict `===` meant a
 * piece the agent saved showed an EMPTY heart on the sheet describing it — the desync the
 * client reported on 2026-09-01.
 */
export function sameVariant(row, variantId) {
  if (!row || !variantId) return false;
  const key = String(variantId).trim().toLowerCase();
  return [row.id, row.variant_id].some(
    (candidate) => candidate != null && String(candidate).trim().toLowerCase() === key,
  );
}

/** Rows of `items` that stand for the sheet's piece. */
function rowsFor(sheet, items) {
  if (!sheet?.variant_id || !Array.isArray(items)) return [];
  return items.filter((row) => sameVariant(row, sheet.variant_id));
}

/** True when the sheet's piece is among the guest's favourites — drives the filled heart. */
export function isSheetWishlisted(sheet, wishlistItems) {
  return rowsFor(sheet, wishlistItems).length > 0;
}

/**
 * How many UNITS of the sheet's piece are in the bag — the number the badge wears.
 *
 * Units, not rows, and scoped to THIS piece rather than the whole bag: the rail chip's badge
 * answers "how big is my bag", but a badge on a per-piece add-to-bag control has to answer
 * "how many of THIS did I add", or it reads as 3 next to a piece that is not in the bag at all.
 * A garment carted in two sizes is two rows of the same variant, hence the sum.
 */
export function sheetBagUnits(sheet, cartItems) {
  return rowsFor(sheet, cartItems).reduce((total, row) => total + itemQuantity(row), 0);
}

/** True when the sheet's piece is in the bag at all. */
export function isSheetInBag(sheet, cartItems) {
  return sheetBagUnits(sheet, cartItems) > 0;
}
